export { default } from './DailyTimeRecordPuncher.js';